import React from 'react'

const Project = () => {
  return (
    <section className='project section'>
        <div className='project__bg'>
            <div className='project__container container grid' id='project-con'>
                <div className='project__data'>
                    <h2 className='project__title'>Do you have new project?</h2>
                    <p className='project__description'>Contact me and get it done...</p>
                    <a href='#contact' className='button button__flex button__white'>
                        Contact Me
                        <i className='uil uil-message project__icon'></i>
                    </a>
                </div>
            </div>
        </div>
    </section>
  )
}

export default Project